/*
 global document, window
 */

const config = {
  BREAKPOINT_MOBILE: 840,
  LOCALIZATION_DATA: window.LOCALIZATION_DATA,
  REQUEST_VERIFICATION_TOKEN: document.querySelector('[name=__RequestVerificationToken]')
    ? document.querySelector('[name=__RequestVerificationToken]').getAttribute('value')
    : '',
  APP_CONFIG: {
    getData(configKey) {
      const configEl = document.querySelector(`#config[name="${configKey}"]`)
      return configEl ? JSON.parse(configEl.getAttribute('value')) : {}
    }
  }
}

export default config
